import { render, staticRenderFns } from "./IncidentsHelpTab.vue?vue&type=template&id=29315140&"
import script from "./IncidentsHelpTab.vue?vue&type=script&lang=js&"
export * from "./IncidentsHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports